import { useQuery } from '@tanstack/react-query';
import { fetchCompany } from '~/api/company';
import { Company, CompanyQueryKeys } from '~/types/company';

export const useCompany = (id: Company['id']) => {
  return useQuery({
    queryKey: CompanyQueryKeys.company(id),
    queryFn: () => fetchCompany(id),
    select: ({ company }) => company,
    enabled: id !== '',
    staleTime: Infinity,
  });
};
